<template>
  <v-container fluid class="admin-page">
    <v-row class="justify-space-between">
      <v-col cols="7">
        <h2>{{ formType.text }} Affiliate</h2>
      </v-col>
      <v-col cols="2">
        <v-btn
          type="submit"
          class="text--futura text--white text-capitalize"
          dark
          block
          @click.prevent="saveAffiliate()"
          :loading="buttonLoading"
          :disabled="buttonLoading"
        >
          {{ formType.value === "new" ? "Save" : "Update" }}
          <template v-slot:loader>
            <v-progress-circular indeterminate color="black"></v-progress-circular>
          </template>
        </v-btn>
      </v-col>
    </v-row>
    <Alert />
    <v-row class="crystal-admin-form justify-space-around pt-5">
      <v-col cols="5">
        <label>Full Name:</label>
        <v-text-field
          solo
          placeholder="Enter full name"
          v-model="affiliate.fullName"
        ></v-text-field>

        <label>Affiliate Code:</label>
        <v-text-field
          solo
          placeholder="Enter affiliate code"
          v-model="affiliate.affiliateCode"
          :readonly="formType.value === 'edit'"
          :append-icon="formType.value === 'new' ? 'mdi-refresh' : ''"
          @click:append="regenerateCode"
          hint="6-letter code. You can edit it before saving."
          persistent-hint
        ></v-text-field>
      </v-col>

      <v-col cols="5">
        <label>Contact Number:</label>
        <v-text-field
          solo
          placeholder="Enter contact number"
          v-model="affiliate.contactNumber"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="justify-end">
      <v-col cols="2">
        <v-btn
          type="submit"
          class="text--futura text--white text-capitalize"
          dark
          block
          @click.prevent="saveAffiliate()"
          :loading="buttonLoading"
          :disabled="buttonLoading"
        >
          {{ formType.value === "new" ? "Save" : "Update" }}
          <template v-slot:loader>
            <v-progress-circular indeterminate color="black"></v-progress-circular>
          </template>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Alert from "@/components/Alert.vue";

export default {
  name: "AffiliateForm",
  components: {
    Alert,
  },
  props: {
    affiliate: {
      type: Object,
      default: () => ({
        fullName: "",
        affiliateCode: "",
        contactNumber: "",
      }),
    },
    formType: {
      type: Object,
      default: () => ({
        text: "Add New",
        value: "new",
      }),
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    saveAffiliate() {
      this.$emit("saveAffiliate");
    },
    regenerateCode() {
      if (this.formType.value === "edit") return;
      this.$emit("regenerateCode");
    },
  },
};
</script>

<style></style>
